import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { AddCompany, EditCompany, GetAllCompanies } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextInputField from "../../components/TextInputField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import SelectField from "../../components/SelectField";

const AddEditCompany = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    company: "select",
    name: "",
    prefix: "",
  });
  const [companys, setCompanys] = useState([]);
  const [mode, setMode] = useState("ADD"); // "ADD" or "EDIT"
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Users");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({
        ...prev,
        [e.name]: option,
        prefix: option.prefix,
        name: option.label,
      }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoading(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key === "name" || (key === "company" && mode === "EDIT")) {
        const error = validateField(key, formData[key], key);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }
    try {
      if (mode === "ADD") {
        const response = await AddCompany(formData.name, formData.prefix);
        if (response.success) {
          showSuccessToast("Success!", "Company added successfully!");
          window.location.reload();
        } else
          showErrorToast(
            "Error!",
            "Company failed to add!\n\n" + response.message,
          );
      } else {
        const response = await EditCompany(
          formData.company.value,
          formData.name,
          formData.prefix,
        );
        if (response.success) {
          showSuccessToast("Success!", "Company updated successfully!");
          window.location.reload();
        } else
          showErrorToast(
            "Error!",
            "Company failed to update!\n\n" + response.message,
          );
      }
    } catch (err) {
      showErrorToast("Error!", "Company failed to add!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      TimeoutUtility.resetTimeout();
      await GetAllCompanies()
        .then((resp) => {
          const cmpOptions = resp.data.map((item) => ({
            label: item.name,
            prefix: item.prefix,
            value: item.company_id,
          }));
          setCompanys(cmpOptions || []);
        })
        .catch((err) => console.log(err.message));
    }
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <div className="flex w-100% items-center justify-between">
        <Header title={`${mode} COMPANY`} />
        <Button
          text={mode === "ADD" ? "Update Old" : "Add New"}
          onClick={() => {
            setMode(mode === "ADD" ? "EDIT" : "ADD");
          }}
          disabled={loading}
        />
      </div>
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                {mode === "EDIT" && (
                  <SelectField
                    label="Company:"
                    name="company"
                    value={formData.company}
                    onChange={handleSelectChange}
                    options={companys}
                    placeholder="Select Company"
                    compulsory={true}
                    error={errors.company}
                  />
                )}
                <TextInputField
                  label="Name:"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  compulsory={true}
                  error={errors.name}
                />
                <TextInputField
                  label="Prefix:"
                  name="prefix"
                  value={formData.prefix}
                  onChange={handleChange}
                  placeholder="Prefix"
                  compulsory={true}
                  error={errors.prefix}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text={mode === "ADD" ? "Add" : "Update"}
          onClick={handleSubmit}
          disabled={loading}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddEditCompany;
